import Axios from 'axios'
import Vue from 'vue'
import getEnv from '@/store/env'

export default {
  authenticate ({ commit }) {
    let kpref = parseInt(localStorage.getItem('kpref'))
    if (kpref === 1) {
      commit('authorizationRequest')
      Vue.prototype.$keycloak.login()
    } else {
      localStorage.setItem('kpref', 1)
      localStorage.setItem('klogin', 1)
      location.reload()
    }
  },
  authenticate2 ({ commit }) {
    let kpref = parseInt(localStorage.getItem('kpref'))
    if (kpref === 2) {
      commit('authorizationRequest')
      Vue.prototype.$keycloak.login()
    } else {
      localStorage.setItem('kpref', 2)
      localStorage.setItem('klogin', 1)
      location.reload()
    }
  },
  // TODO: Figure a way to handle this in a promise in the authenticate action
  //       Currently fails because of the keycloak redirection.
  acceptAuthentication ({ commit }) {
    let token = Vue.prototype.$keycloak.token

    localStorage.setItem('token', token)
    Axios.defaults.headers.common['Authorization'] = 'bearer ' + token

    commit('authorizationSuccess', token)
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')

      localStorage.removeItem('token')
      delete Axios.defaults.headers.common['Authorization']

      Vue.prototype.$keycloak.logoutFn()

      resolve()
    })
  },
  setLocale ({ commit }, code) {
    localStorage.setItem('locale', code)

    commit('localeChange', code)
  },
  setSelectedSignatureProvider ({ commit }, signatureProvider) {
    commit('selectedSignatureProviderSubmission', signatureProvider)
  },
  loadSignatureProviders ({ commit }) {
    return new Promise((resolve, reject) => {
      Axios
        .get(getEnv('VUE_APP_DSS_SIGNING_GATEWAY_FQDN') + '/api/providers/list')
        .then(response => {
          commit('setSignatureProviders', response.data)

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  requestOtp ({ commit }, formData) {
    return new Promise((resolve, reject) => {
      Axios
        .post(
          getEnv('VUE_APP_DSS_SIGNING_GATEWAY_FQDN') + '/api/providers/requestOtp',
          formData
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  uploadDocument ({ commit }, formData) {
    return new Promise((resolve, reject) => {
      Axios
        .post(
          getEnv('VUE_APP_DSS_SIGNING_GATEWAY_FQDN') + '/api/documents/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(response => {
          commit('setUploadedDocument', formData.get('multipartFile'))
          commit('setUploadedDocumentInfo', response.data)

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  signDocument ({ commit }, formData) {
    return new Promise((resolve, reject) => {
      Axios
        .post(
          getEnv('VUE_APP_DSS_SIGNING_GATEWAY_FQDN') + '/api/documents/sign',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(response => {
          commit('setUploadedDocumentInfo', response.data)

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadUploadedDocumentInfo ({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios
        .get(getEnv('VUE_APP_DSS_SIGNING_GATEWAY_FQDN') + '/api/documents/status/' + id)
        .then(response => {
          commit('setUploadedDocumentInfo', response.data)

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadDocument ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Axios
        .get(
          getEnv('VUE_APP_DSS_SIGNING_GATEWAY_FQDN') + '/api/documents/download/' + payload.id,
          {
            params: {
              signed: payload.signed
            },
            responseType: 'blob'
          }
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
